<div class="modal">
  <div class="modal-overlay" (click)="close($event)"></div>

  <div class="modal-dialog w-100 d-flex flex-column align-items-end" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <i class="bi bi-cart4 ms-3"></i>
        @if (isCartCreation) {
          <div class=" ms-1 fw-bold" i18n="@@CartCreationDialogHeading">Creation of a new cart for:</div>
        }
        @if (!isCartCreation) {
          <div class=" ms-1 fw-bold" i18n="@@CartCreationDialogUpdateHeading">Please verify your delivery day:</div>
        }
        <span class="me-auto"></span>
        <i class="btn btn-danger bi bi-x-lg" (click)="close($event)"></i>
      </div>

      <!-- mobile: below each other -->
      <div class="row g-0">
        <div class="col col-12 col-lg-5 p-4">
          <div>
            <!-- Lieferadresse wählen (Select) -->
            <div class="form-floating mt-2">
              <select class="form-select input-field" id="cartCreationDialogDeliveryAddressSelect"
                [(ngModel)]="addressSelected" (change)="deliveryAddressChangedAsync()" required
                name="cartCreationDialogDeliveryAddressSelect">
                @if (addressList != undefined && addressList.length > 0) {
                  @for (address of addressList; track address) {
                    <option [selected]="addressList[0]" [ngValue]="address">
                      {{ addressToCompactStringGet(address) }}
                    </option>
                  }
                }
              </select>
              <label for="cartCreationDialogDeliveryAddressSelect" class="input-label"
              i18n="@@CartCreationDialogAddressSelectLabel">Delivery address</label>
            </div>
          </div>
          <div>
            <!-- Ausgabe der Lieferadresse -->
            <app-address-detail [address]="addressSelected" [isHeaderVisible]="false" [isEmbeddedInCard]="false">
            </app-address-detail>
          </div>
          <div class="d-flex small mt-2">
            <!-- Service-Desk Info -->
            <div class="d-flex justify-content-center align-items-center help-line-caption">
              <span class="mx-2">Helpline</span>
            </div>
            <div class="d-flex justify-content-center align-items-center help-line-number">
              <a href="tel:+352 48 33 33 1">
                <span class="mx-2">+352 48 33 33 1</span>
              </a>
            </div>
            <div class="px-2 small fst-italic">
              du lundi au vendredi
              <br />
              de 8h00 á 16h00
            </div>
          </div>
          <div>

            <!-- Freitext für Kunden-Referenz-Nummer -->
            <div class="form-floating mt-2">
              <input class="form-control input-field" type="text" id="cartCreationDialogCustomerOrderNumberInput"
                [(ngModel)]="customerOrderNumber" (change)="customerOrderNumberChanged()" placeholder=" "
                aria-label="cartCustomerOrderNumber" name="cartCreationDialogCustomerOrderNumberInput">
              <label class="input-label" for="cartCreationDialogCustomerOrderNumberInput"
              i18n="@@CartCreationDialogCustomerOrderNumberLabel">Customer order number</label>
            </div>

            <!-- Freitext für Lieferhinweise -->
            <div class="form-floating mt-2">
              <input class="form-control input-field" type="text" id="cartCreationDialogCommentInput"
                [(ngModel)]="comment" (change)="commentChanged()" placeholder=" " aria-label="cartComment"
                name="cartCreationDialogCommentInput" maxlength="250">
              <label class="input-label" for="cartCreationDialogCommentInput"
                i18n="@@CartCreationDialogCommentLabel">Information
                message</label>
            </div>

          </div>
        </div>
        <div class="col col-12 col-lg-7 cart-creation-dialog-right-column">
          <div class="p-4">
            <!-- Kalender mit Datums-Wahl -->
            <div class="row text-center g-0">
              <!-- Monatswahl -->
              <span class="col-2 c-pointer py-2 fw-bold" (click)="monthDecrement()">&#8810;</span>
              <span class="col cart-creation-dialog-month py-2">{{ monthSelected | monthToStringPipe }} {{ yearSelected
              }}</span>
              <span class="col-2 c-pointer py-2 fw-bold" (click)="monthIncrement()">&#8811;</span>
            </div>

            <!-- Monats-Übersicht -->
            <div class="row text-center small mt-3 g-0">
              <!-- Wochentage - Beschriftung -->
              @for (dayColumn of dayColumnsToDisplay; track dayColumn) {
                <span class="col">{{ dayColumn | eDayOfWeekToStringPipe }}</span>
              }
            </div>

            <!-- Tage - Zellen -->
            <div class="row row-cols-5 text-center g-0">
              @for (calendarDay of calendarDayList; track calendarDay) {
                @if (displayEmptyCellsForDaysOfNeighbouringMonths != true && calendarDay == undefined) {
                  <div class="col"></div>
                }
                @if (calendarDay != undefined || displayEmptyCellsForDaysOfNeighbouringMonths == true) {
                  <app-calendar-day [day]="calendarDay?.date" [isDisabled]="!calendarDay?.isAvailable"
                    [isSelected]="calendarDay?.isSelected" [dayType]="calendarDay?.dayType"
                    (onClicked)="daySelect($event)">
                  </app-calendar-day>
                }
              }
            </div>

            <div class="text-center mt-3">
              <i class="bi bi-truck mx-2"></i>
              @if (dateSelected != undefined) {
                <strong i18n="@@CartCreationDialogDeliveryDateSelected">Delivery for {{ dateSelected | date }}</strong>
              }
              @if (dateSelected == undefined) {
                <strong class="delivery-date-invalid" i18n="@@CartCreationDialogDeliveryDateMissing">Please select a
                  delivery day</strong>
              }
            </div>
          </div>
          @if (isCartCreation) {
            <button class="btn btn-secondary btn-pretty w-100" i18n="@@CartCreationDialogCreateButton"
              (click)="cartCreateClick()" (touchstart)="cartCreateClick()">Create
              my cart
            </button>
          }
          @if (!isCartCreation) {
            <button class="btn btn-secondary btn-pretty w-100" i18n="@@CartCreationDialogUpdateButton"
              (click)="cartCreateClick()" (touchstart)="cartCreateClick()">Update my Cart
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
